import alerts from './alerts';
import alertSystem from './alert-system';
import alertPersonal from './alert-personal';

export default {
  alerts,
  alertSystem,
  alertPersonal,
};
